// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"4de14cc1","455":"7948ee7e","977":"6e88671c"}[chunkId] + ".chunk.js";
};